import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import { Pagination } from "@mui/material";
import classNames from "classnames";
const getPxSize = (size) => {
    if (size === "small")
        return "20px";
    if (size === "medium")
        return "24px";
    if (size === "large")
        return "30px";
    return "20px";
};
const StyledPagination = styled(Pagination)(({ style, size }) => ({
    ".MuiButtonBase-root": {
        color: palette.grey060,
        borderRadius: "6px",
        minWidth: `${getPxSize(size)} !important`,
        height: `${getPxSize(size)} !important`,
        padding: 0,
    },
    ".Mui-selected": {
        color: palette.blue050,
        ...typography["Content.Title04"],
        backgroundColor: "transparent !important",
    },
    ".MuiButtonBase-root:hover": {
        backgroundColor: `${palette.bg020} !important`,
    },
    ...style,
}));
export const GrPagination = ({ size = "medium", className, ...props }) => {
    return _jsx(StyledPagination, { className: classNames("GrMenu", className), ...props, size: size });
};
//# sourceMappingURL=GrPagination.js.map